"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goat = void 0;
exports.goat = {
    "addresses": {
        "ProxyAdmin": "0x30E148a79B898EFa1Ab1285F5Eca71972a7e0acE",
        "Multicall2": "0xcA11bde05977b3631167028862bE2a173976CA11",
        "Sumer": "0x553d713e0fB958932b6C40ABAf0b5A1fFae73Da2",
        "CompoundLens": "0xBB134359b3E6794127c7232680F959CE6BF60814",
        "FeedPriceOracle": "0x607728B392D4d18e7fe072f0F8D4EFd5c8D0F5A4",
        "CompLogic": "0x621492F55F6b7A29FDaC0844B1A6C849985A4b82",
        "RedemptionManager": "0x7032b30FEF73af49e314e5A09B449046ef046309",
        "Timelock": "0x1fbDb3b715c82DCD52BCF06fcc18819951aa9264",
        "Comptroller": "0x98Ec4C9605D69083089eCAf353037b40017b758e",
        "JumpRate#Others": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
        "ZeroRate": "0x313Ba7E5508e3deb17CD5abA9D7A1b15BdE77879",
        "CErc20": "0xe19FD48C972E2dB074C4B0B29Ff2f0d3E1aefe52",
        "suErc20": "0xdD9C863197df28f47721107f94eb031b548B5e48",
        "sdresBTC": "0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E",
        "esBTC": "0xaFB068838136358CFa6B54BEa580B86DF70BBA7f",
        "sdruBTC": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
        "uBTC": "0x78E26E8b953C7c78A58d69d8B9A91745C2BbB258",
        "sdrnETH": "0x7f5a7aE2688A7ba6a9B36141335044c058a08b3E",
        "nETH": "0xd93cC64F0A64044790268C1117BdC7A26A872d2c",
        "sdrsuBTC": "0xAbcdc5827f92525F56004540459045Ec3e432ebF",
        "suBTC": "0xe85411c030fb32a9d8b14bbbc6cb19417391f711",
        "sdrsuETH": "0x7465fedB29023d11effe8C74E82A7ecEBf15E947",
        "suETH": "0x1c22531AA9747d76fFF8F0A43b37954ca67d28e0"
    },
    "tokenPairs": [
        {
            "ctokenSym": "sdresBTC",
            "ctokenAddr": "0xB2fF02eEF85DC4eaE95Ab32AA887E0cC69DF8d8E",
            "underlySym": "esBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xaFB068838136358CFa6B54BEa580B86DF70BBA7f",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdruBTC",
            "ctokenAddr": "0xA6ae238D9CaF65DFA67670FDE3156EFeE9334488",
            "underlySym": "uBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x78E26E8b953C7c78A58d69d8B9A91745C2BbB258",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrnETH",
            "ctokenAddr": "0x7f5a7aE2688A7ba6a9B36141335044c058a08b3E",
            "underlySym": "nETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xd93cC64F0A64044790268C1117BdC7A26A872d2c",
            "assetGroupId": 2
        },
        {
            "ctokenSym": "sdrsuBTC",
            "ctokenAddr": "0xAbcdc5827f92525F56004540459045Ec3e432ebF",
            "underlySym": "suBTC",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0xe85411c030fb32a9d8b14bbbc6cb19417391f711",
            "assetGroupId": 3
        },
        {
            "ctokenSym": "sdrsuETH",
            "ctokenAddr": "0x7465fedB29023d11effe8C74E82A7ecEBf15E947",
            "underlySym": "suETH",
            "ctokenDecimal": 18,
            "underlyDecimal": 18,
            "ctokenIsEther": false,
            "permitEnabled": false,
            "underlyAddr": "0x1c22531AA9747d76fFF8F0A43b37954ca67d28e0",
            "assetGroupId": 2
        }
    ],
    "rateModels": [
        {
            "name": "JumpRate#Others",
            "contract": "JumpRateModelV2",
            "address": "0x6116438fD4abDd902dcA8e0335144F700B1a5147",
            "tokens": [
                "esBTC",
                "uBTC",
                "nETH"
            ],
            "baseRatePerYear": "0.01",
            "multiplierPerYear": "0.15555",
            "jumpMultiplierPerYear": "5.582",
            "kink": "0.45"
        },
        {
            "name": "ZeroRate",
            "contract": "FixedInterestRateModel",
            "address": "0x313Ba7E5508e3deb17CD5abA9D7A1b15BdE77879",
            "tokens": [
                "suBTC",
                "suETH"
            ],
            "initBorrowRate": "0",
            "initSupplyRate": "0"
        }
    ],
    "blocksPerYear": 31536000
};
//# sourceMappingURL=goat.js.map